import React from "react";
import { useLang, LANGUAGES } from "@/i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  const current = LANGUAGES.find((l) => l.code === lang);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-trigger"
          className="flex items-center gap-1.5 text-xs tracking-luxe uppercase text-[#1A1F2C] hover:text-[#C5A880] transition-colors duration-300"
        >
          <Globe className="w-4 h-4" strokeWidth={1.4} />
          {current?.label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none border-[#EAE6E1] min-w-[140px]">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`text-xs tracking-luxe uppercase cursor-pointer ${lang === l.code ? "text-[#C5A880]" : ""}`}
          >
            {l.label} · {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
